<script setup lang="ts">
/** Consent to Short Notice.docx — AFS(PRS040) / UFS(PRS025). 회원 유형별 서두·서명 문구, (b)항은 variant 별 원문. */
import CddVarField from '../../../../preset/components/final-dividends/cdd/CddVarField.vue';
import '../../../../preset/components/final-dividends/docs/agmDoc.css';
import AgmDocHead from '../AgmDocHead.vue';
import AgmMeetingTable from '../AgmMeetingTable.vue';
import AgmSignersPreview from '../AgmSignersPreview.vue';
import { useAgmStudio } from '../agmStudioContext';

defineProps<{ variant: 'afs' | 'ufs' }>();
const { model } = useAgmStudio();
</script>

<template>
  <div class="agm-doc">
    <AgmDocHead registered-office />
    <div class="doc-title">AGREEMENTS UNDER SECTIONS 177(3)(a) AND 203(2)</div>
    <div class="doc-sub">OF THE COMPANIES ACT 1967</div>

    <p v-if="model.memberType === 'multiple'" class="doc-p">We, the undersigned, being all the members of the Company, hereby consent:</p>
    <p v-else-if="model.memberType === 'sole_corporate'" class="doc-p">
      I, <CddVarField field-key="member_representative_name" label="Corporate Representative" />, the undersigned, the duly appointed representative of
      <CddVarField field-key="member_name" label="Sole Corporate Member" />, being the sole member of the Company, hereby consent:
    </p>
    <p v-else class="doc-p">I, <CddVarField field-key="member_name" label="Sole Member" />, the undersigned, being the sole member of the Company, hereby consent:</p>

    <p class="doc-p indent">(a)&nbsp; Pursuant to Section 177(3)(a) of the Companies Act 1967, to the holding of the Annual General Meeting of the Company, notwithstanding that less than the full prescribed notice has been given; and</p>
    <p v-if="variant === 'afs'" class="doc-p indent">(b)&nbsp; Pursuant to Section 203(2) of the Companies Act 1967, to the receipt of the Audited Financial Statements of the Company (including the Directors’ Statement, the Auditors’ Report and every other document required by law to be attached thereto), less than 14 days before the Annual General Meeting.</p>
    <p v-else class="doc-p indent">(b) Pursuant to Section 203(2) of the Companies Act 1967, to the receipt of the Unaudited Financial Statements of the Company (including every document required by law to be attached thereto), less than 14 days before the Annual General Meeting.</p>

    <p class="doc-p">The Annual General Meeting will be held at:</p>
    <AgmMeetingTable order="vdt" />
    <div class="doc-meta">Dated: <CddVarField field-key="consent_date" label="Consent Date" /></div>

    <template v-if="model.memberType === 'multiple'">
      <p class="doc-p">Signed by the members of the Company:</p>
      <AgmSignersPreview doc-kind="consent" />
    </template>
    <template v-else-if="model.memberType === 'sole_corporate'">
      <p class="doc-p">Signed by the duly authorised representative of the sole member of the Company:</p>
      <AgmSignersPreview doc-kind="consent" />
      <div class="doc-p">(Corporate Representative of <CddVarField field-key="member_name" label="Sole Corporate Member" />)</div>
    </template>
    <template v-else>
      <p class="doc-p">Signed by the sole member of the Company:</p>
      <AgmSignersPreview doc-kind="consent" />
      <div class="doc-p">Sole Member</div>
    </template>
  </div>
</template>
